import { useCallback } from "react";
import { useLocation } from "react-router-dom";
import useNavigateFrom from "../../../utils/useNavigateFrom";

import { useRouteCheck } from "../../../hooks/useCurrentEntities";

export default function useCheckFlowNavigate() {
    const { getNextRoute, getPrevRoute, navigateTo, navigateBack } = useNavigateFrom();
    const location = useLocation();
    const check = useRouteCheck();

    const baseUrl = `/layer/${check.layer_id}/add-check/${check.check_id}`;
    const from = new URLSearchParams(location.search).get("from") || `/layer/${check.layer_id}`;

    const navigateToCheckAction = useCallback((action = "", persistent_from = true, params: any = {}, replace = false) => {
        navigateTo(`${baseUrl}/${action}`, persistent_from, params, replace);
    }, [navigateTo, baseUrl]);

    const navigateToAnotherCheck = useCallback(
        (check_id, action = "", persistent_from = true, params: any = {}, replace = false) => {
            navigateTo(`/layer/${check.layer_id}/add-check/${check_id}/${action}`, persistent_from, params, replace);
        },
        [navigateTo, check.layer_id]
    );

    const exitCheckFlow = useCallback(() => navigateBack(from), [navigateBack, from]);

    return { navigateToCheckAction, navigateToAnotherCheck, exitCheckFlow, getNextRoute, getPrevRoute };
}
